import request from '@/utils/request'


// 查询仓库范围列表
export function listWarehouseScope(query) {
  return request({
    url: '/warehouse/warehouse/scope/list',
    headers: { 'repeatSubmit': false },
    method: 'post',
    data: query
  })
}

// 查询仓库范围分页
export function pageWarehouseScope(query) {
  return request({
    url: '/warehouse/warehouse/scope/page',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}

// 查询仓库范围详细
export function getWarehouseScope(data) {
  return request({
    url: '/warehouse/warehouse/scope/detail',
    method: 'get',
    params: data
  })
}

// 新增仓库范围
export function addWarehouseScope(data) {
  return request({
    url: '/warehouse/warehouse/scope/add',
    method: 'post',
    data: data
  })
}

// 修改仓库范围
export function updateWarehouseScope(data) {
  return request({
    url: '/warehouse/warehouse/scope/edit',
    method: 'post',
    data: data
  })
}

// 删除仓库范围
export function delWarehouseScope(data) {
  return request({
    url: '/warehouse/warehouse/scope/delete',
    method: 'post',
    data: data
  })
}
